import { State } from 'src/types'
import { catchFaceOfNormal } from './catchFaceOfNormal'
import { catchFaceOfShallowPocket } from './catchFaceOfShallowPocket'

export const catchFaceDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = state.catchFace.color

  const isShallowWebModel = ['AKG-JS2'].includes(state.baseModel.productNumber)

  if (isShallowWebModel) {
    catchFaceOfShallowPocket(ctx, state.catchFace.color, state.stitch.color)
  }

  if (!isShallowWebModel) {
    catchFaceOfNormal(ctx, state.catchFace.color, state.stitch.color)
  }
}
